import { fetchingProduct } from "../helpers/fetchingProduct";
import { productAdded } from "../helpers/productAdded";
const totalProducts = document.querySelectorAll(
  ".product-article, .component-video-product__product"
);

if (totalProducts.length >= 1) {
  totalProducts.forEach((product) => {
    let addToCart = product.querySelector(".add-to-cart");

    if (addToCart) {
      addToCart.addEventListener("click", () => {
        let productId = addToCart.getAttribute("data-product-id");
        fetchingProduct("/cart/add.js", "POST", "id", productId, 1)
          .then((response) => {
            productAdded(product);
          })
          .catch((error) => {
            console.error("Error al añadir producto:", error.message);
          });
      });
    }
  });
}
